export const handleLineDrag = (x, y, selectedLine, dragPoint, dragPointIndex, dispatch, updateLine, setSelectedLine) => {
  const updatedLine = { ...selectedLine };
  if (updatedLine.points && dragPointIndex !== null) {
    updatedLine.points = [...updatedLine.points];
    updatedLine.points[dragPointIndex] = { x, y };
  } else if (dragPoint) {
    if (dragPoint === 'start') {
      updatedLine.startX = x;
      updatedLine.startY = y;
    } else if (dragPoint === 'end') {
      updatedLine.endX = x;
      updatedLine.endY = y;
    }
  }
  dispatch(updateLine(updatedLine));
  dispatch(setSelectedLine(updatedLine));
};

export const handleAreaDrag = (x, y, selectedArea, dragPointIndex, dispatch, updateArea, setSelectedArea) => {
  const updatedArea = { ...selectedArea };
  updatedArea.points = [...updatedArea.points];
  updatedArea.points[dragPointIndex] = { x, y };
  dispatch(updateArea(updatedArea));
  dispatch(setSelectedArea(updatedArea));
};

export const handleArrowDrag = (x, y, selectedArrow, dragPoint, dispatch, updateArrow, setSelectedArrow) => {
  const updatedArrow = { ...selectedArrow };
  if (dragPoint === 'start') {
    updatedArrow.startX = x;
    updatedArrow.startY = y;
  } else if (dragPoint === 'end') {
    updatedArrow.endX = x;
    updatedArrow.endY = y;
  }
  dispatch(updateArrow(updatedArrow));
  dispatch(setSelectedArrow(updatedArrow));
};

export const handleTextDrag = (x, y, selectedText, dispatch, updateText, setSelectedText) => {
  const updatedText = { ...selectedText, x, y };
  dispatch(updateText(updatedText));
  dispatch(setSelectedText(updatedText));
};

export const handleSquareDrag = (x, y, selectedSquare, dragPoint, dispatch, updateSquare, setSelectedSquare) => {
  const updatedSquare = { ...selectedSquare };
  if (dragPoint === 'topLeft') {
    const newWidth = updatedSquare.width + (updatedSquare.x - x);
    const newHeight = updatedSquare.height + (updatedSquare.y - y);
    updatedSquare.x = x;
    updatedSquare.y = y;
    updatedSquare.width = newWidth;
    updatedSquare.height = newHeight;
  } else if (dragPoint === 'topRight') {
    const newHeight = updatedSquare.height + (updatedSquare.y - y);
    updatedSquare.y = y;
    updatedSquare.width = x - updatedSquare.x;
    updatedSquare.height = newHeight;
  } else if (dragPoint === 'bottomLeft') {
    const newWidth = updatedSquare.width + (updatedSquare.x - x);
    updatedSquare.x = x;
    updatedSquare.width = newWidth;
    updatedSquare.height = y - updatedSquare.y;
  } else if (dragPoint === 'bottomRight') {
    updatedSquare.width = x - updatedSquare.x;
    updatedSquare.height = y - updatedSquare.y;
  }
  dispatch(updateSquare(updatedSquare));
  dispatch(setSelectedSquare(updatedSquare));
};

export const handleCircleDrag = (x, y, selectedCircle, dragPoint, dispatch, updateCircle, setSelectedCircle) => {
  const updatedCircle = { ...selectedCircle };
  if (dragPoint === 'top' || dragPoint === 'bottom') {
    updatedCircle.radiusY = Math.abs(y - updatedCircle.centerY);
  } else if (dragPoint === 'left' || dragPoint === 'right') {
    updatedCircle.radiusX = Math.abs(x - updatedCircle.centerX);
  }
  dispatch(updateCircle(updatedCircle));
  dispatch(setSelectedCircle(updatedCircle));
};

export const handleLegendDrag = (x, y, selectedLegend, dragPoint, dispatch, updateLegend, setSelectedLegend) => {
  const updatedLegend = { ...selectedLegend };
  if (dragPoint === 'topLeft') {
    const newWidth = updatedLegend.width + (updatedLegend.x - x);
    const newHeight = updatedLegend.height + (updatedLegend.y - y);
    updatedLegend.x = x;
    updatedLegend.y = y;
    updatedLegend.width = newWidth;
    updatedLegend.height = newHeight;
  } else if (dragPoint === 'topRight') {
    const newHeight = updatedLegend.height + (updatedLegend.y - y);
    updatedLegend.y = y;
    updatedLegend.width = x - updatedLegend.x;
    updatedLegend.height = newHeight;
  } else if (dragPoint === 'bottomLeft') {
    const newWidth = updatedLegend.width + (updatedLegend.x - x);
    updatedLegend.x = x;
    updatedLegend.width = newWidth;
    updatedLegend.height = y - updatedLegend.y;
  } else if (dragPoint === 'bottomRight') {
    updatedLegend.width = x - updatedLegend.x;
    updatedLegend.height = y - updatedLegend.y;
  }
  dispatch(updateLegend(updatedLegend));
  dispatch(setSelectedLegend(updatedLegend));
};